export const RGPD = {
  RGPD_MAIN_DESCRIPTION: 'COMMON_RGPD_MAIN_DESCRIPTION',
  RGPD_SHOW_SETTINGS: 'COMMON_RGPD_SHOW_SETTINGS',
  RGPD_BACK: 'COMMON_RGPD_BACK',
  RGPD_ACCEPTANCE_QUESTION_GTAG: 'COMMON_RGPD_ACCEPTANCE_QUESTION_GTAG',
  RGPD_KNOW_MORE: 'COMMON_RGPD_KNOW_MORE',
  RGPD_NO_ACCEPTANCE: 'COMMON_RGPD_NO_ACCEPTANCE',
  RGPD_YES_ACCEPTANCE: 'COMMON_RGPD_YES_ACCEPTANCE',
  RGPD_SAVE: 'COMMON_RGPD_SAVE',
  RGPD_ACCEPTANCE_QUESTION_ALGOLIA: 'COMMON_RGPD_ACCEPTANCE_QUESTION_ALGOLIA',
  RGPD_ACCEPTANCE_QUESTION_PRISMIC: 'COMMON_RGPD_ACCEPTANCE_QUESTION_PRISMIC',
};
